import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full justify-between flex-nowrap" }
const _hoisted_2 = {
  key: 0,
  class: "get-build-cache"
}
const _hoisted_3 = {
  key: 0,
  class: "shorter-builds flex flex-col gap-2 wide-only"
}
const _hoisted_4 = { class: "text gordita-400-13 text-Text/text_medium" }
const _hoisted_5 = { class: "w-full gordita-500-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-arrow-right text-[22px]" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "wide h-full flex items-center wide-only"
}

import { useI18n } from 'vue-i18n';
import { IncrediChartBar, IncrediButton } from 'incredi-ui';
import COLORS from '@/design-system/colors.json';
import { envConfig } from '@/services/features';
import { useOsService } from '@/services/OsService/OsService';
import { convertBaseTimeToSSMMHH } from '@/views/dashboard/dashboard.charts.utils';
import DashboardOverviewTitle from './dashboard-overview-title.vue';
import DashboardOverviewDetails from './dashboard-overview-details.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-overview-avg-builds',
  props: {
    avgOverall: null,
    avgWithBuildCache: null,
    avgWithoutBuildCache: null,
    hasBuildCacheInLicense: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  avgOverall?: number;
  avgWithBuildCache?: number;
  avgWithoutBuildCache?: number;
  hasBuildCacheInLicense?: boolean;
}

const { t } = useI18n();
const osService = useOsService();


const sections = [
  { title: t('dashboard.statusBar.seeOverallAvgAbove'), value: props.avgOverall, color: COLORS['Brand/yellow'] },
  { title: t('dashboard.statusBar.withBuildCache'), value: props.avgWithBuildCache, color: COLORS['System/app_secondary'] },
  { title: t('dashboard.statusBar.withoutBuildCache'), value: props.avgWithoutBuildCache, color: COLORS['Text/text_medium'] },
];

const getBuildCache = () => {
  const win = window.open(envConfig.dashboardGetBuildCache, '_blank');
  win?.focus();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardOverviewDetails, {
    legend: 
      __props.hasBuildCacheInLicense
        ? [
            { title: _unref(t)('dashboard.statusBar.seeOverallAvgAbove'), value: '', class: 'bg-Brand/yellow' },
            { title: _unref(t)('dashboard.statusBar.withBuildCache'), value: _unref(convertBaseTimeToSSMMHH)(__props.avgWithBuildCache || 0, 'seconds', true), class: 'bg-System/app_secondary' },
            {
              title: _unref(t)('dashboard.statusBar.withoutBuildCache'),
              value: _unref(convertBaseTimeToSSMMHH)(__props.avgWithoutBuildCache || 0, 'seconds', true),
              class: 'bg-Text/text_medium',
            },
          ]
        : []
    
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DashboardOverviewTitle, {
          class: "pb-3",
          title: _unref(t)('dashboard.statusBar.avgBuildDuration'),
          value: _unref(convertBaseTimeToSSMMHH)(__props.avgOverall || 0, 'seconds', true)
        }, null, 8, ["title", "value"]),
        (!__props.hasBuildCacheInLicense)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_unref(osService).isWindows.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.statusBar.getShorterBuilds')), 1),
                    _createVNode(_unref(IncrediButton), {
                      size: "small",
                      class: "w-full text-center",
                      "data-testid": "get-build-cache",
                      disabled: !_unref(envConfig).dashboardGetBuildCache,
                      onClick: getBuildCache
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('dashboard.statusBar.buildCacheButton')), 1),
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (__props.hasBuildCacheInLicense)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(IncrediChartBar), {
              style: {"width":"100px","height":"120px"},
              height: "120px",
              width: "100px",
              class: "bar-chart",
              "chart-id": "avgBuildDuration",
              labels: [],
              options: {
          barWidth: 20,
          width: 60,
          height: 120,
          cursor: 'default',
          legend: {
            show: false,
          },
          toolbox: {
            show: false,
          },
          grid: {
            containLabel: false,
            left: 16,
            right: 100,
            top: 1,
            bottom: 0,
          },
          tooltip: {
            show: false,
          },
          xAxis: {
            boundaryGap: false,
            data: sections.map(section => section.title),
            show: false,
          },
          yAxis: {
            show: false,
          },
          dataZoom: [
            {
              show: false,
            },
            {
              show: false,
            },
          ],
        },
              series: [
          {
            type: 'bar',
            data: sections.map(({ value, color }) => ({ value, itemStyle: { color } })),
          },
        ]
            }, null, 8, ["options", "series"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["legend"]))
}
}

})